import {ConfigurationForm} from "../forms";


export default function ConfigurationScreen(props) {
  return (
    <div className="container" style={{maxWidth: '600px'}}>

      <p className="text-center mb-4">Podaj wymiary wnęki (cm)</p>

      <div className="mb-4">
          <ConfigurationForm
              dimensions={props.dimensions}
              onSubmit={props.onSubmit}
          />
      </div>

        <p className="small">
            Podaj szerokość oraz wysokość wnęki. W przypadku podania niestandardowej szerokości lub wysokości wnęki (patrz wysokości/szerokości drzwi),
            zostanie dodane naświele górne / boczne.
        </p>
        <div className="row">
            <div className="col-md-6">
                <p className="small">
                    Szerokości drzwi:
                    <ul>
                        <li>"80"</li>
                        <li>"90"</li>
                        <li>"100"</li>
                        <li>"110"</li>
                        <li>"120"</li>
                    </ul>
                </p>
            </div>
            <div className="col-md-6">
                <p className="small">
                    Wysokości drzwi:
                    <ul>
                        <li>200 cm</li>
                        <li>205 cm</li>
                        <li>210 cm</li>
                        <li>215 cm</li>
                        <li>220 cm</li>
                    </ul>
                </p>
            </div>
        </div>



    </div>
  )
}
